import { ConfigurationService } from './../../modules/configuration/configuration.service';
import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'app/services/global.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-refund-deny',
  templateUrl: './refund-deny.component.html',
  styles: [
  ]
})
export class RefundDenyComponent implements OnInit {
  @Input() data: any;
  denyForm:FormGroup
  submitted = false
  loader = false
  orderID = "";

  constructor(
    public  fb     : FormBuilder,
    public  global : GlobalService,
    public configService : ConfigurationService,
    public dialogRef : NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.denyForm = this.fb.group({
      message : ['',[Validators.required]]
    });
  }
  get f() {
    return this.denyForm.controls
  }
  
  onSubmit(){
    this.orderID = this.data.info['orderID'][0]['_id']
    this.submitted = true
    this.loader = true

    if (this.denyForm.invalid) {
      return
    }

    const denyData = {
      notes: {
        message : this.denyForm.value['message']
      }
    }
    console.log(this.orderID,denyData);
    
    this.configService.denyRefund(this.orderID,denyData).then((response)=>{
      this.loader = false
      console.log(response);
      this.close()
    }).catch(err=>{
      this.loader = false
      this.global.failureErrorModal(err);
    });
  }

  close() {
    this.dialogRef.close({ success: false })
  }
}
